var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import IconosApp, { Icono } from './IconosApp';
import theme from '../Theme';
import cxs from 'cxs/component';
var FieldIcon = /** @class */ (function (_super) {
    __extends(FieldIcon, _super);
    function FieldIcon() {
        /*  constructor(props: Props<T>, context: any) {
            super(props, context)
            this.state = {selected: props.icon}
            console.log('props.icon: ', this.state.selected)
          }*/
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selected: _this.props.icon
        };
        _this.handleClick = function (icon) {
            console.log(icon);
            if (_this.state.selected === icon) {
                _this.setState({ selected: '' });
                _this.props.onChange('icon', '', 'icon');
            }
            else {
                _this.setState({ selected: icon });
                _this.props.onChange('icon', icon, 'icon');
            }
        };
        return _this;
    }
    FieldIcon.prototype.render = function () {
        var _this = this;
        var _a = this.props, icons = _a.icons, onChange = _a.onChange;
        var selected = this.state.selected;
        // console.log('render - selected: ', selected)
        return (React.createElement("div", null, icons.map(function (icon, index) {
            return React.createElement("div", { key: icon, onClick: function () { return _this.handleClick(icon); }, style: { position: 'relative', display: 'inline-block' } }, selected === icon
                ? (React.createElement("div", null,
                    React.createElement(StyledIconosApp, { name: Icono[icon], style: style.selected })))
                : (React.createElement("div", null,
                    React.createElement(StyledIconosApp, { name: Icono[icon], style: style.square }))));
        })));
    };
    return FieldIcon;
}(Component));
export default FieldIcon;
var StyledIconosApp = cxs(IconosApp)({
/*':hover': {
  color: theme.color.primary
},*/
});
var style = {
    square: {
        /*fontFamily: 'icons',*/
        fontSize: '70px',
        border: "1px solid ".concat(theme.color.secondary)
        /*color: theme.color.secondary*/
    },
    selected: {
        /*fontFamily: 'icons',*/
        fontSize: '70px',
        border: "1px solid ".concat(theme.color.secondary),
        color: theme.color.primary
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldIcon.tsx
// module id = 952
// module chunks = 0